export const PREVIEW_BACKGROUND_TYPE: LocalRepositoryKey = "ApolloStudio_PreviewBackground_Type";
export const PREVIEW_BACKGROUND_CRS: LocalRepositoryKey = "ApolloStudio_PreviewBackground_Crs";
export const PREVIEW_BACKGROUND_BOUNDS: LocalRepositoryKey = "ApolloStudio_PreviewBackground_Bounds";
export const PREVIEW_BACKGROUND_URL: LocalRepositoryKey = "ApolloStudio_PreviewBackground_Url";
export const PREVIEW_BACKGROUND_SUBDOMAINS: LocalRepositoryKey = "ApolloStudio_PreviewBackground_Subdomains";
export const PREVIEW_BACKGROUND_LAYERNAME: LocalRepositoryKey = "ApolloStudio_PreviewBackground_Layername";
export const ADD_DATA_ADVANCED_OPTIONS_KEY: LocalRepositoryKey = "ApolloStudio_addDataAdvancedOptions";
export const ADD_DATA_OTHER_OPTIONS_KEY: LocalRepositoryKey = "ApolloStudio_addDataOtherOptions";
export const DATA_LIST_PAGE_OPTIONS_KEY: LocalRepositoryKey = "ApolloStudio_dataListPageOptions";

export type LocalRepositoryKey = "ApolloStudio_PreviewBackground_Type" |
    "ApolloStudio_addDataAdvancedOptions" |
    "ApolloStudio_addDataOtherOptions" |
    "ApolloStudio_PreviewBackground_Bounds" |
    "ApolloStudio_PreviewBackground_Crs" |
    "ApolloStudio_PreviewBackground_Url" |
    "ApolloStudio_PreviewBackground_Subdomains" |
    "ApolloStudio_PreviewBackground_Layername" |
    "ApolloStudio_dataListPageOptions";

class LocalRepository {
  setParameter(key: LocalRepositoryKey, value: string) {
    window.localStorage.setItem(key, value);
  }

  getParameter(key: LocalRepositoryKey) {
    return window.localStorage.getItem(key);
  }

  setOptions(key: LocalRepositoryKey, value: unknown) {
    const strValue = JSON.stringify(value);

    window.localStorage.setItem(key, strValue);
  }

  getOptions<T>(key: LocalRepositoryKey) {
    const strValue = window.localStorage.getItem(key);

    if (strValue === null) {
      return null;
    }

    return JSON.parse(strValue) as T;
  }
}

export const localRepository = new LocalRepository();